import Analytics from 'analytics'
import segmentPlugin from '@analytics/segment'
import { getLiveConfigurationCache } from './configuration/configurationCache'
import cdpDumpPlugin from './cdpDumpPlugin'
import { shouldPresentBFeature } from './featureCohortTesting'

let segmentAnalytics = null
let plickersAnalytics = null

function initAnalytics() {
  segmentAnalytics = Analytics({
    app: 'plickers-web',
    plugins: [
      segmentPlugin({
        writeKey: process.env.REACT_APP_SEGMENT_KEY,
      }),
    ],
  })
  plickersAnalytics = Analytics({
    app: 'plickers-web',
    plugins: [
      cdpDumpPlugin({
        appName: 'plickers-web',
        writeKey: process.env.REACT_APP_CDPDUMP_WRITE_KEY,
        host: process.env.REACT_APP_CDPDUMP_HOST,
        endpointPrefix: '/cdp/v1',
        // enableDebugLogging: true, // enable this to get more logs into browser console
      }),
    ],
  })
}

export function getAnalyticsProvider() {
  const userId = JSON.parse(localStorage.getItem('ls.session'))?.user
  const liveConfig = getLiveConfigurationCache() || {}
  const {
    analyticsProviderProbabilityUser,
    analyticsProviderProbabilityAnonymous,
  } = liveConfig

  if (userId) {
    const defaultProbabilityUser = process.env.REACT_APP_ANALYTICS_PROVIDER_DEFAULT_PROBABILITY_USER || '0'
    const userProbability = analyticsProviderProbabilityUser ?? defaultProbabilityUser
    return shouldPresentBFeature('analyticsProviderUser', userId, userProbability) ?
      'plickers' : 'segment'
  }

  const segmentAnonymousId = window.analytics?.user?.().anonymousId()
  const defaultProbabilityAnonymous = process.env.REACT_APP_ANALYTICS_PROVIDER_DEFAULT_PROBABILITY_ANONYMOUS || '0'
  const anonymousProbability = analyticsProviderProbabilityAnonymous ?? defaultProbabilityAnonymous
  if (segmentAnonymousId) {
    return shouldPresentBFeature('analyticsProviderAnonymous', segmentAnonymousId, anonymousProbability) ?
      'plickers' : 'segment'
  } if (parseInt(anonymousProbability, 10) === 100) {
    // if no userId or segment anonymousId is available and
    // anonymousProbability is 100, choose plickers
    return 'plickers'
  }
}

function getAnalyticsInstance() {
  const analyticsProvider = getAnalyticsProvider()
  if (analyticsProvider === 'segment' && isSegmentInitialized()) {
    return segmentAnalytics
  }
  if (analyticsProvider === 'plickers') {
    return plickersAnalytics
  }
}

function isSegmentInitialized() {
  return !!window.analytics
}

function track(eventName, properties = {}) {
  const analytics = getAnalyticsInstance()
  if (analytics) {
    analytics.track(eventName, properties)
  }
}

function page(pageName, properties = {}) {
  const analytics = getAnalyticsInstance()
  if (analytics) {
    analytics.page({
      name: pageName,
      ...properties,
    })
  }
}

function identify(userId, traits = {}) {
  const analytics = getAnalyticsInstance()
  if (analytics) {
    analytics.identify(userId, traits)
  }
}

function reset() {
  const analytics = getAnalyticsInstance()
  if (analytics) {
    analytics.reset()
  }
}

export default {
  initAnalytics,
  track,
  page,
  identify,
  reset,
}
